import { CustomerCounts } from '../../../../../../model/ReportingMetrics';
import NumericalValueTile from '../core/NumericalTile/NumericalTile';
import { MetricsTileComponent } from '../core/MetricsTile/MetricsTile';
import { useTranslation } from 'react-i18next';
import { useFormattedMetricsValues } from '../core/NumericalTile/NumericalTile.utils';

export interface ICustomerCountsTileProps {
    previousCounts: CustomerCounts;
    currentCounts: CustomerCounts;
}

const CustomerCountsTile: MetricsTileComponent<ICustomerCountsTileProps> = ({
    title,
    previousCounts,
    currentCounts,
    className,
}) => {
    const { t } = useTranslation();

    const values = useFormattedMetricsValues(
        [
            {
                label: t('ReportingDashboard_NotifiedCount'),
                previous: previousCounts.notified,
                current: currentCounts.notified,
            },
            {
                label: t('ReportingDashboard_NotNotifiedCount'),
                previous: previousCounts.notNotified,
                current: currentCounts.notNotified,
            },
            {
                label: t('ReportingDashboard_TotalCount'),
                previous: previousCounts.notified + previousCounts.notNotified,
                current: currentCounts.notified + currentCounts.notNotified,
            },
        ],
        { size: 'small' }
    );

    return (
        <NumericalValueTile
            title={title}
            values={values}
            className={className}
        />
    );
};

export default CustomerCountsTile;
